import { get, post, put } from "./api"

export async function getProgramsForUser(userId = null) {
  try {
    const url = userId ? `coach/programsForUser?userId=${userId}` : 'coach/programsForUser'
    return await get(url)
  } catch (error) {
    return { error }
  }
}

export async function getCoachProgramById(id) {
  try {
    return await get(`coach/getProgram/${id}`)
  } catch (error) {
    return { error }
  }
}

export async function adminAssignDirectorToProgram(programId, directorId, sendEmails = false, isFirstDirector = false) {
  try {
    const program = { director: directorId }
    // If this is the first director assignment, also set status to confirmed
    if (isFirstDirector) {
      program.status = 'confirmed'
    }
    return await post(`admin/program/${programId}/update`, {
      program,
      sendEmails
    })
  } catch (error) {
    return { error }
  }
}

export async function sendCustomEmailForProgram(programId, formData) {
  try {
    return await post(`program/${programId}/customEmail`, formData)
  } catch (error) {
    return { error }
  }
}

// type RescheduleSessionType = {
//   date: string
//   newDate: string
//   reason: string
//   lateNoticeFlag: boolean
//   coachIsResponsible: boolean
// }
export async function rescheduleProgramSession(programId, formData) {
  try {
    return await post(`program/${programId}/rescheduleSession`, formData)
  } catch (error) {
    return { error }
  }
}

// type CancelSessionType = {
//   date: string
//   reason: string
//   followUpAction: string
//   lateNoticeFlag: boolean
//   coachIsResponsible: boolean
// }
export async function cancelProgramSession(programId, formData) {
  try {
    return await post(`program/${programId}/cancelSession`, formData)
  } catch (error) {
    return { error }
  }
}

export async function fetchProgramsForParams(params) {
  try {
    return await post('fetch_programs_for_params', params)
  } catch (error) {
    return { error }
  }
}

export async function updateProgram(programId, programData, sendEmails = false) {
  try {
    return await put(`admin/program/${programId}/update`, {
      program: programData,
      sendEmails
    })
  } catch (error) {
    return { error }
  }
}

export async function addProgram(programData) {
  try {
    return await post('admin/program/add', { program: programData })
  } catch (error) {
    return { error }
  }
}

export async function getProgramById(id) {
  try {
    return await get(`coach/getProgram/${id}`)
  } catch (error) {
    return { error }
  }
}

export async function substituteCoachInSession(data) {
  try {
    return await post('programSession/substituteCoach', data)
  } catch (error) {
    return { error }
  }
}

export async function updateSessionCoaches(sessionId, { add = [], remove = [], propagate = false } = {}) {
  try {
    return await put(`programSession/${sessionId}/coaches`, { add, remove, propagate })
  } catch (error) {
    return { error }
  }
}